import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatTimeAgo(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  
  return date.toLocaleDateString('en-NG', { 
    month: 'short', 
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-NG', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatPhone(phone) {
  if (!phone) return '';
  // Format Nigerian phone numbers
  if (phone.startsWith('+234')) {
    return phone.replace(/(\+234)(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
  }
  return phone;
}

export function getStatusColor(status) {
  const colors = {
    'NEW': 'status-new',
    'VALIDATED': 'status-validated',
    'DISPATCHED': 'status-dispatched',
    'ESCALATED': 'status-escalated',
    'COMPLETED': 'status-completed',
    'CANCELED': 'status-canceled'
  };
  return colors[status] || 'bg-slate-500/15 text-slate-600';
}

export function getSeverityColor(incidentClass) {
  const colors = {
    'L1/L2': 'severity-l1l2',
    'L3/L4': 'severity-l3l4',
    'L5': 'severity-l5'
  };
  return colors[incidentClass] || 'severity-l1l2';
}

export function getSeverityBgColor(incidentClass) {
  const colors = {
    'L1/L2': '#6B21A8',
    'L3/L4': '#F59E0B',
    'L5': '#B91C1C'
  };
  return colors[incidentClass] || '#6B21A8';
}

export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}
